import gql from 'graphql-tag';

const MUTATION_CREATE_ACCOUNT_WITHOUT_PASSWORD = gql`
	mutation CreateAccountWithoutPassword($firstname: String!, $lastname: String!, $zip: String!, $email: String!) {
		createAccountWithoutPassword(firstname: $firstname, lastname: $lastname, zip: $zip, email: $email)
 	}
`;

export default MUTATION_CREATE_ACCOUNT_WITHOUT_PASSWORD;